import { defineMessages } from "react-intl"

export const OTHER_MSGS = defineMessages({
  other: {
    id: "Claims.options.other",
    description: "option other on claim",
    defaultMessage: "Other"
  }
})
